import ChatLayout from 'layout/chat/farm/chatLayout';
import {ProtectedRoute} from 'modules/protectedRoute/market';
import ChatFormContainer from './chatContainer';
import {RouteObject} from 'react-router-dom';

export const FarmChatRoutes: RouteObject[] = [
  {
    path: 'farm/chat-form',
    element: (
      <ProtectedRoute>
        <ChatLayout />
      </ProtectedRoute>
    ),
    errorElement: <>error page</>,
    children: [
      {
        index: true,
        path: ':chatId',
        element: <ChatFormContainer />,
      },
    ],
  },
];
